import { render } from "./HeroApplicantDetails.vue?vue&type=template&id=2d2aff96"
import script from "./HeroApplicantDetails.vue?vue&type=script&lang=js"
export * from "./HeroApplicantDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__